import { BaseRestDataProvider } from './BaseRestDataProvider';
import { CustomerInvoice } from '../models/CustomerInvoice';

export class CustomerInvoiceRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/customer-invoices');
  }

  getAll(): Promise<CustomerInvoice[]> {
    return this.get<CustomerInvoice[]>(``);
  }

  getById(id: string): Promise<CustomerInvoice> {
    return this.get<CustomerInvoice>(`/${id}`);
  }

  add(invoice: CustomerInvoice): Promise<CustomerInvoice> {
    return this.post<CustomerInvoice>(``, invoice);
  }

  update(id: string, invoice: CustomerInvoice): Promise<void> {
    return this.put<void>(`/${id}`, invoice);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }

  book(id: string): Promise<void> {
    return this.postVoid(`/${id}/book`);
  }

  bookPayment(id: string, paymentDate: string, isCreditNote = false): Promise<void> {
    return this.postVoid(`/${id}/book-payment`, { paymentDate, isCreditNote });
  }
}

export type { CustomerInvoice };
